module.exports = __webpack_public_path__ + "img/1.323c65ae.jpg";